import { QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { AppRouter } from './app/router'
import { GlobalToastHost } from './components/GlobalToastHost'
import { queryClient } from './lib/queryClient'
import { setupServiceWorkerAutoReload } from './lib/swAutoReload'
import { initializeTheme } from './store/themeStore'
import './index.css'

// Aplica el tema (light/dark) al <html> antes del primer render para evitar
// flash of wrong theme (FOWT) cuando la preferencia del usuario no coincide
// con el default del sistema.
initializeTheme()

// Un deploy no debe requerir Ctrl+F5: cuando el service worker nuevo toma el
// control, la pestaña se recarga para dejar de correr el bundle anterior.
setupServiceWorkerAutoReload()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRouter />
      <GlobalToastHost />
    </QueryClientProvider>
  </StrictMode>,
)
